import {gql} from '@apollo/client';
import {CustomerComplaint} from '../types/CustomerComplaintType';

export const GET_CUSTOMER_COMPLAINT_BY_ID = gql`
    query GetCustomerComplaintById($id: Long!) {
        getCustomerComplaintById(id: $id) {
            id
            complaintCategory
            complaintType
            complaintReason {
                text
                lang
                translations {
                    lang
                    text
                }
            }
            source
            externalRefId
            externalRefCode
            driverId
            dspId
            orderId
            trackingNumber
            hubId
            warehouseId
            evidenceFilesJson
            status
            isFinished
            appealDeadlineAt
            finishedAt
            createdAt
            updatedAt
            appealSubmittedAt
            warehouseName
            dspName
            thirdSortingCode
            driverName
            orderOverallStatus
            podImageS3UrlsJson
            operatorName
            recipientAddress
            recipientName
            recipientPhoneCountryCode
            recipientPhoneNumber
            recipientLatitude
            recipientLongitude
        }
    }
`;

export interface GetCustomerComplaintByIdResponse {
    getCustomerComplaintById?: CustomerComplaint;
}

export interface GetCustomerComplaintByIdVariables {
    id: number;
}
